import React,{ Component } from 'react';
import {Modal, Table, Checkbox} from 'antd'

const columns = [
    {
        title: 'PO Number',
        dataIndex: 'poNumber',
    },
    {
        title: 'Sold to',
        dataIndex: 'soldToNumber',
    },
    {
        title: 'Ship to',
        dataIndex: 'shipToNumber',
    },
    {
        title: 'Bill to',
        dataIndex: 'billToNumber',
    },
    {
        title: 'Invoice No.',
        dataIndex: 'invoiceNumber',
    },
    {
        title: 'Item No.',
        dataIndex: 'invoiceItemNo',
    },
    {
        title: 'Part Number',
        dataIndex: 'partNumber',
    },
    {
        title: 'Description',
        dataIndex: 'partNumberDesc',
    },
    {
        title: 'Billed Quantity',
        dataIndex: 'quantity',
    },
    {
        title: 'SU',
        dataIndex: 'salesUnit',
    },
    // {
    //     title: 'Net Value',
    //     dataIndex: 'netValue',
    // },
    {
        title: 'Net Price',
        dataIndex: 'netValueUnit',
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
    },
    {
        title: 'Sales Order',
        dataIndex: 'orderNumber',
    },
    // {
    //     title: 'Sales Order Item',
    //     dataIndex: 'SalesOrderItem',
    // },
    {
        title: 'Delivery',
        dataIndex: 'deliveryNumber',
    },
];

class TableModels extends Component{
    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state={
            isModalVisible:props.ModalVisible,
            serial_number:props.serial_number,
            formRef:this.formRef,
            data:[]
        }
    }

    static getDerivedStateFromProps (nextProps, prevState) {
        const {serial_number} = nextProps;
        if (serial_number !== prevState.serial_number) {
            return {
                serial_number,
            };
        }
        return null;
    }

    // componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
    //     if(this.formRef.current){
    //             // this.formRef.current.setFieldsValue({Invoice:this.state.serial_number})
    //     }
    // }

    render(){
        return <Modal width={1200} title="Select Part Number"
                      visible={this.props.ModalVisible}
                      onOk={this.props.handleOk}
                      onCancel={this.props.handleCancel}>
            <Table
                scroll={{ x: 2000 ,y: 500}}
                rowKey={'invoiceItemNo'}
                rowSelection={{
                    type: Checkbox,
                    onChange:this.props.dataChecked,
                    selectedRowKeys: this.props.selectedRowKeys,
                    // getCheckboxProps: (record) => ({
                    //     disabled: record.name === 'Disabled User',
                    //     name: record.name,
                    // }),
                }}
                columns={columns}
                dataSource={this.props.ValidateData?this.props.ValidateData.invoiceItems:[]}
            />
        </Modal>
    }

}

export default TableModels;

